import React, { Component, useState } from 'react';
import {
	Collapse,
	Button,
	Navbar,
	NavbarToggler,
	NavbarBrand,
	Nav,
	NavItem,
	NavLink,
	UncontrolledDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	NavbarText
} from 'reactstrap';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import './styles.scss';

const MenuCollapsable = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  return (
    <div>
      <h4 onClick={toggle} className="p-1">{props.menu.Nombre}</h4>
      <Collapse isOpen={isOpen}>
		<Nav vertical className="navbar-submenu-color">
			<NavItem><NavLink href={"#" + props.menu.href}>{"TODOS LOS ARTICULOS"}</NavLink></NavItem>
		{
			props.menu.submenues && props.menu.submenues.length > 0 &&
			props.menu.submenues.map(
				(submenu, index) => (
					<NavItem key={"sidebarsubmenu-"+index}>
						<NavLink className="py-1" href={"#"+submenu.href}>
							{submenu.Nombre}
						</NavLink>
						{/* Submenues anidados */}
						{submenu.submenues && submenu.submenues.length > 0 && (
							<ul class="ms-3 nav">
								{submenu.submenues.map((subitem, subIndex) => (
									<NavItem key={"subsubmenu-"+index+"-"+subIndex}>
										<NavLink 
											className="py-1" 
											href={"#"+subitem.href}
										>
											{subitem.Nombre}
										</NavLink>
									</NavItem>
								))}
							</ul>
						)}
					</NavItem>
				)
			)
		}
		</Nav>
      </Collapse>
    </div>
  );
}

class Sidebar extends Component {
	constructor(props) {
		super(props);
		let Menues = this.props.Menues;
		this.state = {
			Menues: Menues,
			redirect:false,
			url:'',
			displayNone:true,
		}
	}

	static propTypes = {
		Menues: PropTypes.array,
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.Menues !== this.props.Menues) {
			this.setState(prevState => {
				prevState.Menues = nextProps.Menues;
				return prevState;
			});
		}
	}

	toggleSidebar(e) {
		try {
			let displayNone = !this.state.displayNone;
			if (document.body.classList.contains('sidebar-show'))
				document.body.classList.remove('sidebar-show');
			else
				document.body.classList.add('sidebar-show');
			if(
				e!=undefined && e.target != undefined && e.target.attributes != undefined &&
				e.target.attributes.href != undefined && e.target.attributes.href.value != '#'){
				let url = e.target.attributes.href.value.replace("#","");
				this.setState(
					{redirect:true,url:url},
					()=>this.setState({redirect:false, displayNone:displayNone},
						()=>{
							if (document.body.classList.contains('sidebar-show'))
								document.body.classList.remove('sidebar-show');
						}
					)
				);
			}
			else{
				this.setState({displayNone:displayNone});
			}
		} catch (ex) {
			console.log(ex)
		}
	}

	render() {
		let { Menues, displayNone } = this.state;
		if(this.state.redirect == true){
			return <Redirect to={this.state.url}/>
		}else{
			return (
				<div className="sidebar overflow-scroll pb-2" onClick={(e) => this.toggleSidebar(e)}>
				{Menues.map((x, i) => <MenuCollapsable key={"menu-"+i} menu={x}/>)}
				</div>
			);
		}
	}
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js